// Centralised SEO metadata for every routed page.
// Keep titles ≤ 60 chars & descriptions ≤ 160 chars where possible.
const SITE_URL = "https://45dayspaces.com";
const OG_IMAGE = "https://customer-assets.emergentagent.com/job_dream-design-deliver/artifacts/c6d5zg1i_Main.png";

export const siteMeta = {
    siteName: "45DaySpaces",
    siteUrl: SITE_URL,
    ogImage: OG_IMAGE,
    twitterHandle: "@45DaySpaces",
    phone: "+971552239345",
};

export const pageSeo = {
    home: {
        title: "45DaySpaces | Dubai Interiors & Fit-Out Delivered in 45 Days",
        description: "45DaySpaces delivers office fit-outs, home interiors, retail spaces and restaurant interiors in Dubai through a structured 45-day execution plan. Get a free estimate today.",
        path: "/",
        keywords: "interior design Dubai, fit-out Dubai, office fit-out Dubai, home interiors Dubai, retail branding Dubai, restaurant interiors Dubai, 45DaySpaces",
        ogImage: OG_IMAGE,
    },
    office: {
        title: "Office Fit-Out Dubai | Office Renovation & Commercial Interiors | 45DaySpaces",
        description: "Get office fit-out, renovation, workstations, partitions, reception areas, furniture, branding and handover support in Dubai with 45DaySpaces.",
        path: "/office-fit-out-dubai",
        keywords: "office fit-out Dubai, office renovation Dubai, commercial interiors Dubai, workstations Dubai, office partitions Dubai, reception design Dubai",
        ogImage: "https://customer-assets.emergentagent.com/job_dream-design-deliver/artifacts/83t8nwft_Fitout.jpg",
    },
    homeInteriors: {
        title: "Home Interiors Dubai | Apartment & Villa Interior Design | 45DaySpaces",
        description: "45DaySpaces designs and delivers premium apartment and villa interiors in Dubai, including kitchens, wardrobes, furniture, lighting and final styling.",
        path: "/home-interiors-dubai",
        keywords: "home interiors Dubai, apartment interior design Dubai, villa interior design Dubai, kitchen design Dubai, wardrobe design Dubai",
        ogImage: "https://customer-assets.emergentagent.com/job_dream-design-deliver/artifacts/rhhmp5k8_Home.jpg",
    },
    retail: {
        title: "Retail Branding Dubai | Store Fit-Out & Retail Interiors | 45DaySpaces",
        description: "45DaySpaces helps Dubai retail brands with store interiors, storefronts, display zones, lighting, customer flow and launch-ready retail branding.",
        path: "/retail-branding-dubai",
        keywords: "retail branding Dubai, store fit-out Dubai, retail interiors Dubai, storefront design Dubai, showroom design Dubai",
        ogImage: "https://customer-assets.emergentagent.com/job_dream-design-deliver/artifacts/sc7pkfad_Retail.jpg",
    },
    restaurant: {
        title: "Restaurant Interiors Dubai | Café Fit-Out & Hospitality Design | 45DaySpaces",
        description: "Design and deliver restaurant and café interiors in Dubai with seating layouts, lighting, counters, finishes, branding and handover support.",
        path: "/restaurant-interiors-dubai",
        keywords: "restaurant interiors Dubai, café fit-out Dubai, hospitality design Dubai, restaurant design Dubai, café interior design Dubai",
        ogImage: "https://images.unsplash.com/photo-1552566626-52f8b828add9?auto=format&fit=crop&w=1400&q=85",
    },
};

// LocalBusiness JSON-LD (shared across pages)
export const localBusinessJsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `${SITE_URL}/#organization`,
    name: "45DaySpaces",
    url: SITE_URL,
    logo: "https://customer-assets.emergentagent.com/job_dream-design-deliver/artifacts/mfputtlc_45DaySpaces.com%20Logo.webp",
    image: OG_IMAGE,
    description: "Interior design and fit-out company delivering office, home, retail and restaurant spaces across Dubai in a 45-day execution plan.",
    telephone: "+971552239345",
    priceRange: "AED",
    areaServed: [
        { "@type": "City", name: "Dubai" },
        { "@type": "City", name: "Abu Dhabi" },
        { "@type": "City", name: "Sharjah" },
    ],
    address: {
        "@type": "PostalAddress",
        streetAddress: "Pantone 9, 8 27 Street, Al Qouz Ind. Second",
        addressLocality: "Al Quoz, Dubai",
        addressCountry: "AE",
    },
    sameAs: [],
};

export const serviceJsonLd = (service) => ({
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: service.type,
    provider: { "@type": "LocalBusiness", name: "45DaySpaces", url: SITE_URL },
    areaServed: { "@type": "City", name: "Dubai" },
    name: service.name,
    description: service.description,
    url: `${SITE_URL}${service.path}`,
});

export const faqJsonLd = (items) => ({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
        "@type": "Question",
        name: it.q,
        acceptedAnswer: { "@type": "Answer", text: it.a },
    })),
});
